<template>
  <div class="tool-modal-ead d-flex flex-column gap-4">
    <snow-select
      v-model="form.product_id"
      id="product-select"
      label="Nome do produto"
      :disabled="isEdit"
      :errors="errors.product_id"
      :options="products.map(({ id, name }) => ({ id, name }))"
      required
    />
    <snow-input
      v-model="form.description"
      id="description"
      label="Descrição da integração (Opcional)"
    />
    <snow-input
      v-model="form.url"
      id="url"
      label="URL"
      placeholder="Digite a URL"
      :rules="rules.url"
      required
    />
    <snow-input
      v-model="form.token"
      id="token"
      label="Token"
      :rules="rules.token"
      required
    />
    <snow-input
      v-model="form.course"
      type="number"
      id="course-id"
      label="ID do curso"
      :rules="rules.course"
      required
    />

    <div class="snow-submit-buttons">
      <snow-button
        size="lg"
        class="order-lg-0 order-1"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        :text="isEdit ? 'Salvar' : 'Integrar'"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
import { required, validUrl } from "@/functions/validation";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(
        ["product_id", "url", "status", "token", "course", "description"],
        {
          ...this.integrationToEdit,
          course: this.integrationToEdit?.extras?.course
        }
      )
    };
  },
  computed: {
    isValid() {
      return (
        this.form.product_id &&
        this.form.course &&
        this.form.token &&
        this.form.url
      );
    },
    rules() {
      return {
        url: [required(), validUrl()],
        token: [required()],
        course: [required()]
      };
    }
  }
};
</script>
